import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { IEmployee } from '@entities/employee/model/types';
import { useDeleteEmployee } from '@entities/myTeam/lib/hooks';
// import { reloadPage } from '@shared/helpers';

interface IUseEmployeeActions {
    currentEmployeeId: IEmployee['id'];
    employeeId: IEmployee['id'];
}

export const useEmployeeActions = ({ employeeId, currentEmployeeId }: IUseEmployeeActions) => {
    const employeeMutation = useDeleteEmployee();
    const [isShowPopup, setIsShowPopup] = useState(false);
    const onHidePopup = () => {
        setIsShowPopup(false);
    };

    const onShowPopup = () => {
        setIsShowPopup(true);
    };

    const onDelete = async () => {
        setIsShowPopup(false);
        await employeeMutation.mutateAsync({ employeeId, currentEmployeeId });
        // console.log('res', res);
        // if (currentEmployeeId === employeeId && res.data.startsWith('<!DOCTYPE html')) {
        //     console.log('res', res);
        //     reloadPage();
        // }
    };

    const { t } = useTranslation();

    return { t, isShowPopup, onHidePopup, onDelete, onShowPopup };
};
